"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var languages_1 = __importDefault(require("../available/languages"));

var themes_1 = __importDefault(require("../available/themes"));
/**
 * @param language
 * @return CSS class for a prism language
 */


exports.getLanguageClassName = function (language) {
  if (language && languages_1.default.includes(language)) {
    return "language-" + language;
  }

  return '';
};
/**
 * @param theme
 * @return CSS class for a prism theme
 */


exports.getThemeClassName = function (theme) {
  if (theme && themes_1.default.includes(theme)) {
    return "codeblock-theme-" + theme;
  }

  return '';
};